import React from 'react';
import {UseFormReturn} from "react-hook-form";
import {FormOperacionCorporateLendingDetalle, OperacionCorporateLendingDetalle} from "../types/types";
import {Button, Grid} from "@mui/material";
import {ControlledDatePicker, ControlledTextField} from "../../../../../components/forms";
import {OperacionCorporateLendingDetalleFields} from "../types/fields";

interface CorporateLendingDetalleFormProps {
  codPais: number,
  formMethods: UseFormReturn<FormOperacionCorporateLendingDetalle>,
  onSubmitForm: (data: FormOperacionCorporateLendingDetalle) => void,
  detalle?: OperacionCorporateLendingDetalle,
}


function CorporateLendingDetalleForm({
                                       codPais,
                                       formMethods,
                                       onSubmitForm,
                                       detalle,
                                       ...props
                                     }: CorporateLendingDetalleFormProps) {

  const {control, handleSubmit, watch, setValue, formState: {errors}} = formMethods;

  return (
    <Grid container spacing={3} sx={{mt: 1}}>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Deudor}
          label='Deudor'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Acreedor}
          label='Acreedor'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Moneda}
          label='Moneda'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Monto}
          label='Monto'
          size={'small'}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Destino}
          label='Destino de los Fondos'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.PlazoDisponibilidad}
          label='Plazo de Disponibilidad'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Plazo}
          label='Plazo'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Amortizacion}
          label='Amortización'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Comision}
          label='Comisión por Disponibilidad'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Precancelacion}
          label='Precancelación'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.TasaInteres}
          label='Tasa de Interés'
          fullWidth
          size={'small'}
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.FrecuenciaInteres}
          label='Frecuencia de Pago de Interés'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.FiadorAvalista}
          label='Fiador y Avalista'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Garantias}
          label='Garantías'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Pagare}
          label='Pagaré'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Covenants}
          label='Covenants'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionCorporateLendingDetalleFields.Ley}
          label='Ley y Jurisdicción'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledDatePicker
          control={control}
          name={OperacionCorporateLendingDetalleFields.FechaEjecucion}
          label='Fecha de Ejecución del Mutuo'
          fullWidth
        />
      </Grid>

      {
        detalle &&
          <Grid item container xs={12} justifyContent={'flex-end'} direction={'row'} mt={3}>
              <Grid item container xs={4} justifyContent={'flex-end'}>
                  <Button variant='contained' color='primary' onClick={handleSubmit(onSubmitForm)}>
                      Confirmar
                  </Button>
              </Grid>
          </Grid>
      }

    </Grid>
  );
}

export default CorporateLendingDetalleForm;